import api from './api'

const resource = '/master/regions'
// console.log('tokennn')
// console.log(localStorage.getItem('accessToken'))
api.defaults.headers.common['x-access-token'] = localStorage.getItem('accessToken');

export default {
    get(page, q) {
        return api.get(`${resource}?page=${page}&q=${q}`);
    },
    getAll() {
        return api.get(`${resource}?per_page=100`);
    },
    getPost(slug){
        return api.get(`${resource}?slug=${slug}`);
    }
}